"use client"

import { Component } from "react"
import axios from "axios"
import { URL_PATH, root_url } from "../../services/API"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import routes from "../../routes/URL"


class MainScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      qrData: [],
      loading: true,
      error: null,
      hoveredCard: null,
      selectedQr: null,
      showQrModal: false,
    }
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getQr()
  }

  getQr = async () => {
    try {
      const id = this.props.selectedHotelId.id
      const token = localStorage.getItem("token")
      if (!token) {
        console.error("❌ etable_token not found in localStorage")
        return
      }

      const response = await axios.get(`${root_url}/api/hotelowner/hotel/showQr/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      console.log("hellloooo", response)
      const qrData = Array.isArray(response.data.data)
        ? response.data.data.map((qr) => ({
          ...qr,
          // qr_path: qr.qr_path?.replace("https://static.etableapp.com", "https://static-dev.etableapp.com"),
          qr_path: qr.qr_path

        }))
        : []

      console.log("✅ Modified QR Codes Data:", qrData)

      this.setState({
        qrData,
        loading: false,
      })
    } catch (error) {
      console.error("❌ Error fetching QR codes:", error.response ? error.response.data : error)
      this.setState({
        error: "Failed to fetch QR code data",
        loading: false,
      })
    }
  }

  setHoveredCard = (id) => {
    this.setState({ hoveredCard: id })
  }

  clearHoveredCard = () => {
    this.setState({ hoveredCard: null })
  }

  handleDownload = (qrPath, tableNo) => {
    const link = document.createElement("a")
    link.href = qrPath
    link.download = `Table_${tableNo}_QR.png`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  renderQrDetails = () => {
    const { qrData } = this.state
    const hotelName = this.props.selectedHotelId?.hotel_name || "Mini Cafeteria"

    if (!qrData.length) {
      return <p className="no-data">No QR code data available.</p>
    }

    return (
      <div className="qr-gallery">
        {qrData.map((qr, index) => (
          <div key={index} className="qr-item">
            <div className="qr-item-inner">
              <div className="qr-item-front">
                <div className="qr-item-header" style={{ color: "white", backgroundColor: "#FFC857" }}>
                  <div className="qr-floor-info" style={{ color: " #02111B" }}>{qr.hotel_floor.floor_no || "1"}</div>
                  <div className="qr-table-info" style={{ color: " #02111B" }}>{qr.table_no || "1"}</div>
                </div>

                <div className="qr-item-body" style={{ backgroundColor: "#041A29", border: "1px solid #FFC857 ", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>
                  <div className="qr-code-wrapper">
                    <img
                      src={qr.qr_path || "/placeholder.svg"}
                      alt={`QR Code for Table ${qr.table_no || "1"}`}
                      className="qr-code-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  getTableQrCodes = async () => {
    const hotel_id = this.props.selectedHotelId.id
    const url = URL_PATH.printTableQr + `?id=${hotel_id}`
    console.log("Unique QR URL:", url)

    window.open(url, "_blank")
  }

  getHotelQrCodes = async () => {
    const hotel_id = this.props.selectedHotelId.id
    const url = URL_PATH.printHotelQr + `?id=${hotel_id}`
    console.log("Common QR URL:", url)

    window.open(url, "_blank")
  }

  render() {
    const { loading, error } = this.state

    return (
      <>
        <Header title="QR Code" />

        <div className="qr-manager">
          <style>
            {`
            :root {
              --background: #121212;
              --surface: #1E1E1E;
              --primary: #041A29;
              --secondary: #03DAC6;
              --error: #CF6679;
              --on-background: #FFFFFF;
              --on-surface: #FFFFFF;
              --on-primary: #000000;
              --on-third: #FFC857;
              --on-secondary: #000000;
              --on-error: #000000;
              --card-radius: 8px;
            }
            
            body {
              background-color: var(--background);
              color: var(--on-background);
              margin: 0;
              padding: 0;
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            }
            
            .qr-manager {
              max-width: 2000px;
              margin: 0 auto;
              padding: 24px;
            }
            
            .button-container {
              display: flex;
              justify-content: center;
              gap: 16px;
              margin-bottom: 32px;
              flex-wrap: wrap;
            }
            
            .action-button {
              background-color: #FFC857;
              color: var(--on-primary);
              border: none;
              padding: 12px 24px;
              border-radius: 4px;
              font-weight: 700;
              font-size: 14px;
              letter-spacing: 0.5px;
              cursor: pointer;
              transition: transform 0.2s, box-shadow 0.2s;
            }
            
            .action-button:hover {
              background-color: #FFC857;
              box-shadow: 0 4px 8px rgba(0,0,0,0.2);
              transform: translateY(-2px);
            }
            
            .action-button:active {
              transform: translateY(1px);
            }
            
            .loading-message, .error-message, .no-data {
              background-color: var(--surface);
              border-radius: var(--card-radius);
              padding: 16px;
              text-align: center;
              margin: 24px auto;
              max-width: 400px;
            }
            
            .loading-message {
              color: var(--on-surface);
            }
            
            .error-message {
              color: var(--error);
            }
            
            .no-data {
              color: var(--secondary);
            }
            
            .qr-gallery {
              display: grid;
              grid-template-columns: repeat(6, 1fr);
              gap: 20px;
            }
            
            .qr-item {
              perspective: 1000px;
            }
            
            .qr-item-inner {
              position: relative;
              width: 100%;
              height: 100%;
              transition: transform 0.6s;
              transform-style: preserve-3d;
            }
            
            .qr-item-front {
              background-color: var(--surface);
              border-radius: var(--card-radius);
              overflow: hidden;
              display: flex;
              flex-direction: column;
              height: 100%;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
              transition: box-shadow 0.3s ease;
            }
            
            .qr-item:hover .qr-item-front {
              box-shadow: 0 10px 20px rgba(0,0,0,0.15);
            }
            
            .qr-item-header {
              padding: 6px 16px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .qr-floor-info {
              font-size: 14px;
              font-weight: 600;
              padding: 4px 10px;
              border-radius: 4px;
            }
            
            .qr-table-info {
              font-size: 14px;
              font-weight: 600;
              padding: 4px 10px;
              border-radius: 4px;
            }
            
            .qr-item-body {
              padding: 16px;
              display: flex;
              flex-direction: column;
              align-items: center;
              flex-grow: 1;
            }
            
            .qr-code-wrapper {
              background-color: white;
              padding: 12px;
              border-radius: 4px;
              margin-bottom: 16px;
              width: 60%;
              max-width: 200px;
              aspect-ratio: 1/1;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            
            .qr-code-image {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
            
            /* Responsive Design */
            @media (max-width: 2000px) {
              .qr-gallery {
                grid-template-columns: repeat(5, 1fr);
              }
            }
            
            @media (max-width: 1600px) {
              .qr-gallery {
                grid-template-columns: repeat(4, 1fr);
              }
            }
            
            @media (max-width: 1200px) {
              .qr-gallery {
                grid-template-columns: repeat(3, 1fr);
              }
            }
            
            @media (max-width: 900px) {
              .qr-gallery {
                grid-template-columns: repeat(2, 1fr);
                gap: 16px;
              }
              
              .qr-manager {
                padding: 16px;
              }
            }
            
            @media (max-width: 600px) {
              .qr-gallery {
                grid-template-columns: 1fr;
                max-width: 400px;
                margin: 0 auto;
              }
              
              .button-container {
                flex-direction: column;
                align-items: center;
              }
              
              .action-button {
                width: 100%;
                max-width: 300px;
                margin-bottom: 12px;
              }
            }
          `}
          </style>

          <div className="button-container">
  <div
    style={{
      backgroundColor: "#FFC857",
      color: "black",
      boxShadow: "none",
      borderRadius: "8px",
      fontWeight:"700px",
      borderWidth: "1px",
      borderColor: "#FFC857",
      borderStyle: "solid", // ✅ Add this
      padding: "10px 15px",  // Optional: for better button-like feel
      cursor: "pointer",     // Optional: makes it feel clickable
      display: "inline-block",
      margin: "5px" 
    }}
    onClick={this.getHotelQrCodes}
  >
    Download Waiting Lounge QR Code
  </div>

  <div
    style={{
      backgroundColor: "#02111B",
      color: "white",
            fontWeight:"700px",

      boxShadow: "none",
      borderRadius: "8px",
      borderWidth: "1px",
      borderColor: "#FFC857",
      borderStyle: "solid", // ✅ Add this
      padding: "10px 15px",
      cursor: "pointer",
      display: "inline-block",
      margin: "5px"
    }}
    onClick={this.getTableQrCodes}
  >
    Download Unique Table QR Code
  </div>
</div>


          {loading && <div ></div>}
          {error && <div className="error-message">{error}</div>}
          {!loading && !error && this.renderQrDetails()}
        </div>
      </>
    )
  }
}

export default redux(MainScreen)